export enum ELevelKey {
  L1 = 'l1',
  L2 = 'l2',
  L3 = 'l3',
  L4 = 'l4',
}

export enum EProgressStep {
  START = 0,
  QUARTER = 25,
  HALF = 50,
  THREE_QUARTERS = 75,
  COMPLETE = 100,
}

export enum ERewardMode {
  /** the bonus is credited on its own, the player only activates it */
  AUTO = 'auto',
  /** L4: a lootbox arrives and the player picks a prize inside it */
  LOOTBOX = 'lootbox',
}

export enum ELevelState {
  LOCKED = 'locked',
  IN_PROGRESS = 'inProgress',
  /** target reached, the reward is issued and waits to be activated */
  ISSUED = 'issued',
  CLAIMED = 'claimed',
}

export enum EWeeklyRewardState {
  /** Level 1 is not completed this week, nothing is earned yet */
  LOCKED = 'locked',
  /** a level is completed, the reward grows with every next one */
  SECURED = 'secured',
  /** the week is over, the reward arrives on Monday 12:00 UTC */
  PENDING = 'pending',
  /** the reward of the last week has been credited */
  ISSUED = 'issued',
}

export interface ILevelConfig {
  key: ELevelKey;
  order: number;
  startAmount: number;
  targetAmount: number;
  rewardMode: ERewardMode;
  artifact: string;
  // the pumpkin in the hero grows with the level
  heroCharsDesk: string;
  heroCharsMob: string;
}

export interface IStatusGroup {
  levelKey: ELevelKey;
  step: EProgressStep;
}

export interface ILevel extends ILevelConfig {
  state: ELevelState;
  progress: number;
}

export interface ICycle {
  /** 0-based, the week of the promo */
  index: number;
  start: Date;
  end: Date;
  isLast: boolean;
}
